import { createSlice } from "@reduxjs/toolkit";

import { fetchHistory } from "../thunks/historyThunk";

import type { History } from "../../utils/types/type-helper";

interface HistoryState {
  history: History[];
  loading: boolean;
  error: string | null;
}

const initialState: HistoryState = {
  history: [],
  loading: false,
  error: null,
};

const history = createSlice({
  name: "history",
  initialState,
  reducers: {
    clearHistory: (state) => {
      state.history = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload || [];
      })
      .addCase(fetchHistory.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
  },
});

export const { clearHistory } = history.actions;

export default history.reducer;
